export const APP_OPENED = 'APP_OPENED';
export const USER_AUTHORIZE = 'USER_AUTHORIZE';
export const SHOW_PUSH_NOTIFICATION = 'SHOW_PUSH_NOTIFICATION';
export const PUSH_NOTIFICATION_CLICK = 'PUSH_NOTIFICATION_CLICK';
export const SERVICE_WORKER_ACTIVATED = 'SERVICE_WORKER_ACTIVATED';
export const REMOVE_NOTIFICATIONS_AND_BADGES = 'REMOVE_NOTIFICATIONS_AND_BADGES';
export const SKIP_WAITING = 'SKIP_WAITING';
